
import homeDbarResource from "./home-dbar-resource";

export default {
    vi: {
        homeDbarResource: homeDbarResource.vi
    },
    en: {
        homeDbarResource: homeDbarResource.en
    }
}